var map = {
	"./": 4155,
	"./en": 4997,
	"./en/": 4997,
	"./en/categories": 52347,
	"./en/categories.ts": 52347,
	"./en/countries": 3831,
	"./en/countries.ts": 3831,
	"./en/currencies": 46264,
	"./en/currencies.ts": 46264,
	"./en/emissionItemCategories": 43507,
	"./en/emissionItemCategories.ts": 43507,
	"./en/fuelTypes": 78184,
	"./en/fuelTypes.ts": 78184,
	"./en/ghgCategories": 22429,
	"./en/ghgCategories.ts": 22429,
	"./en/index": 4997,
	"./en/index.ts": 4997,
	"./en/translations": 47615,
	"./en/translations.ts": 47615,
	"./en/vehicleTypes": 85898,
	"./en/vehicleTypes.ts": 85898,
	"./index": 4155,
	"./index.ts": 4155,
	"./nb": 96126,
	"./nb/": 96126,
	"./nb/categories": 91882,
	"./nb/categories.ts": 91882,
	"./nb/countries": 33148,
	"./nb/countries.ts": 33148,
	"./nb/currencies": 74645,
	"./nb/currencies.ts": 74645,
	"./nb/emissionItemCategories": 81138,
	"./nb/emissionItemCategories.ts": 81138,
	"./nb/fuelTypes": 26083,
	"./nb/fuelTypes.ts": 26083,
	"./nb/ghgCategories": 84289,
	"./nb/ghgCategories.ts": 84289,
	"./nb/index": 96126,
	"./nb/index.ts": 96126,
	"./nb/translations": 64306,
	"./nb/translations.ts": 64306,
	"./nb/vehicleTypes": 37615,
	"./nb/vehicleTypes.ts": 37615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85002;